module.exports = __webpack_public_path__ + "img/login_image.66b0a347.png";